import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Createproject } from 'src/app/model/createproject.model';
import { UserService } from '../../../services/user/user.service';
import { EvaluationService } from 'src/app/services/evaluation/evaluation.service';
import { Vendordata } from 'src/app/model/vendordata.model';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';



@Component({
  selector: 'app-addpurchaseorder',
  templateUrl: './addpurchaseorder.component.html',
  styleUrls: ['./addpurchaseorder.component.css']
})
export class AddpurchaseorderComponent implements OnInit {
  hours: number[] = Array.from({ length: 12 }, (_, i) => i + 1); // 1 to 12
  minutes: string[] = Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0')); // 00 to 59
  ampm: string[] = ['AM', 'PM'];

  roleId: string;
  project: Createproject;
  dropdownSettings = {};
  dropdownSettings2 = {};
  dropdownSettingTeamMember = {};

  countryData: any;
  languageData: any;
  projectName: string;
  proposalCode:string;
  clientName: string;
  desc: string;
  data: any;
  dataL: any;
  dataForId: Vendordata;
  evaluationDataAny: any;
  generateLinkBool: boolean = true;
  compeleteURL: string;
  terminateURL: string;
  quotafullURL: string;
  quotarejectURL: string;
  generateLinkBoolNew: boolean = false;
  generateLinkBoolNew2: boolean = false;
  textBoxBool: boolean = false;
  generateRedirects: boolean = false;
  isDataLoading: boolean = false;
  dataTeamMember: any;
  redirectLink: any[] = [];

  constructor(private userService: UserService, private route: ActivatedRoute, private router: Router, private evaluationService: EvaluationService) {
    this.roleId = this.route.snapshot.params.projectid;
    this.projectName = this.route.snapshot.params.projectname;    
    this.clientName = this.route.snapshot.params.clientname;
    this.desc = this.route.snapshot.params.desc;
    this.proposalCode = this.route.snapshot.params.proposalCode;

  }

  ngOnInit() {
    //alert(this.roleId)
    debugger;
    this.dropdownSettings = {
      singleSelection: true,
      idField: 'countryID',
      textField: 'countryName',
      allowSearchFilter: true,
      closeDropDownOnSelection: true
    };
    this.dropdownSettings2 = {
      singleSelection: true,
      idField: 'languageID',
      textField: 'language',
      allowSearchFilter: true,
      closeDropDownOnSelection: true
    };
    
    this.dropdownSettingTeamMember = {
      // singleSelection: true,
      idField: 'id',
      textField: 'fullName',
      allowSearchFilter: true,
      // closeDropDownOnSelection: true
    };
    this.getTeamMemberList();
    this.project = new Createproject();
    this.resetForm();
    if (this.roleId == undefined || this.roleId == "") {
      this.textBoxBool = true;
      this.generateLinkBool = true;
      this.evaluationService.getAllVendorsForEvaluationForProjectId().subscribe(
        (data) => {
          this.evaluationDataAny = data;
          //this.evaluationData = this.evaluationDataAny;
          this.dataForId = this.evaluationDataAny;
          if (this.dataForId != null && this.evaluationDataAny != null) {
            if (this.evaluationDataAny.length > 0) {
              var id = this.evaluationDataAny.length;
              this.project.projectid = "P100000" + id;
            }
            else {
              this.project.projectid = "P1000000";
            }
          }
          else {
            this.project.projectid = "P1000000";
          }
          //console.log("hello",this.dataForId);
          this.roleId = this.project.projectid
          this.generateRedirects = false;
          this.project.waitingTime = 20;

        }


      )
    }

    else {
      debugger;
      this.userService.getTeamMemberList().subscribe(() => {
        // Ensure all users are loaded before selecting team members
        this.userService.getAssignTeamsToProject(this.roleId).subscribe((data: any) => {
          if (data && Array.isArray(data)) {
            const selectedIds = data.map((member: any) => member.userID);

            // Ensure `dataTeamMember` has loaded before filtering
            setTimeout(() => {
              this.project.teamMember = this.dataTeamMember.filter(member => selectedIds.includes(member.id));
              console.log("Pre-selected team members:", this.project.teamMember);
            }, 500); // Small delay to ensure dataTeamMember is available
          }
        });
      });

      this.textBoxBool = false;
      this.generateLinkBool = false;
      this.generateLinkBoolNew = false;
      this.generateLinkBoolNew2 = true;
      this.generateRedirects = false;
      this.project.projectid = this.roleId;
      // this.project.projectname = this.projectName;
      // this.project.clientname = this.clientName;
      // this.project.projectdescription = this.desc;
      this.project.projectname =decodeURIComponent(this.projectName);      
      this.project.clientname =decodeURIComponent(this.clientName);
      this.project.projectdescription = decodeURIComponent(this.desc);
      this.project.proposalCode =decodeURIComponent(this.proposalCode);
      
      this.project.waitingTime = 20;
    }

    this.getCountryList();
    //this.getLanguageList();
  }


  redirectLinkData = [
  { item_id: 'oldLink', item_text: 'Old Link' },
  { item_id: 'newLink', item_text: 'New Link' }
];

redirectLinkSettings = {
  singleSelection: true,
  idField: 'item_id',
  textField: 'item_text',
  allowSearchFilter: false,
  closeDropDownOnSelection: true
};

  getCountryList() {
    this.userService.getCountryList().subscribe(
      (data) => {
        debugger;
        this.countryData = data;
        this.data = this.countryData;
        console.log("country list" + this.data[0]);
      }
    )
  }
  onCountrySelect(item: any) {
    console.log(item);
    if (item != null) {
      this.getLanguageList();
    }
  }

  onCountryDropDownClose(country: any) {
    console.log("on cancel");
    console.log(country);
    if (!country) {
      this.dataL = [];
      this.project.language = null;
    }
    else {
      if (country.length == 0) {
        this.dataL = [];
        this.project.language = null;
      }
    }


  }

  getLanguageList() {
    debugger;
    this.userService.getLanguageList().subscribe(
      (data) => {
        this.languageData = data;
        this.dataL = this.languageData;
        //console.log("user data" + this.dataL);
      }
    )
  }
  
  getTeamMemberList() {
    debugger;
    this.userService.getTeamMemberList().subscribe(
      (data) => {
        this.dataTeamMember = data;
        // this.dataL = this.languageData;
        //console.log("user data" + this.dataL);
      }
    )
  }

  getLanguageListForSurvey(countryID) {
    if (countryID != null && this.roleId != "") {
      this.userService.getLanguageListForSurvey(this.roleId, countryID).subscribe(
        (data: any) => {
          this.dataL = data;
        }
      )
    }
  }

  OnSubmit(form: NgForm) {
    debugger
    this.isDataLoading = true;
    console.log(form.value);
    console.log(window.location.href)

    this.projectName = form.value.projectname;
    this.proposalCode = form.value.proposalCode;
    this.clientName = form.value.clientName;
    this.desc = this.route.snapshot.params.desc;

    this.compeleteURL = window.location.href;
    this.terminateURL = window.location.href;
    this.quotafullURL = window.location.href;
    this.quotarejectURL = window.location.href;

    // this.compeleteURL = this.compeleteURL.replace("createproject", "StartSurvey/"+this.project.projectid+"/1/[RE]");
    // this.terminateURL = this.terminateURL.replace("createproject", "StartSurvey/"+this.project.projectid+"/3/[RE]");
    // this.quotafullURL = this.quotafullURL.replace("createproject", "StartSurvey/"+this.project.projectid+"/2/[RE]");
    // this.quotarejectURL = this.quotarejectURL.replace("createproject", "StartSurvey/"+this.project.projectid+"/4/[RE]");
    
    // this.compeleteURL = this.compeleteURL.replace("createproject", "StartSurvey/" + "1/[RE]");
    // this.terminateURL = this.terminateURL.replace("createproject", "StartSurvey/" + "3/[RE]");
    // this.quotafullURL = this.quotafullURL.replace("createproject", "StartSurvey/" + "2/[RE]");
    // this.quotarejectURL = this.quotarejectURL.replace("createproject", "StartSurvey/" + "4/[RE]");

    if (this.redirectLink && this.redirectLink.length > 0) {

  if (this.redirectLink[0].item_id === 'newLink') {

    this.compeleteURL = this.compeleteURL.replace("createproject","StartSurvey/1/RE=[RE]");
    this.terminateURL = this.terminateURL.replace("createproject","StartSurvey/3/RE=[RE]");
    this.quotafullURL = this.quotafullURL.replace("createproject","StartSurvey/2/RE=[RE]");
    this.quotarejectURL = this.quotarejectURL.replace("createproject","StartSurvey/4/RE=[RE]");

  } else if (this.redirectLink[0].item_id === 'oldLink') {

    this.compeleteURL = this.compeleteURL.replace("createproject","StartSurvey/1/[RE]");
    this.terminateURL = this.terminateURL.replace("createproject","StartSurvey/3/[RE]");
    this.quotafullURL = this.quotafullURL.replace("createproject","StartSurvey/2/[RE]");
    this.quotarejectURL = this.quotarejectURL.replace("createproject","StartSurvey/4/[RE]");
  }
}


    form.value.projectid = this.roleId;
    form.value.complete = this.compeleteURL;
    form.value.terminate = this.terminateURL;
    form.value.qf = this.quotafullURL;
    form.value.qcreject = this.quotarejectURL;
    form.value.teamMember = Array.isArray(this.project.teamMember) ? this.project.teamMember.map((member: any) => member.id) : [''];
    // form.value.teamMember = (this.project && Array.isArray(this.project.teamMember)) ? this.project.teamMember.map((member: any) => (member ? member.id : null)) : [];
    form.value.country = this.project.country[0]['countryID'];
    form.value.language = this.project.language[0]['languageID'];
   // form.value.teamMember = this.project.teamMember.map((member: any) => member.id)
   

    this.userService.addProjectDetails(form.value)
      .subscribe((data: any) => {
        this.isDataLoading = false;
        if (data != null && data != undefined) {
          this.generateRedirects = true;
          this.generateLinkBool = false;
          this.generateLinkBoolNew = true;
          this.generateLinkBoolNew2 = false;
        }
        else 
        {
          alert("An error occured while creating project. Project with same ID already exist.")
        }
      });
  }

  resetForm(form?: NgForm) {
    if (form != null)
      form.reset();
    this.project = new Createproject;
  }

  OptionSelected(event) {
    debugger;
    console.log("event", event.target.value);
  }

  clickSurveyLinkFormat(project) {
    debugger;
    console.log("NewProject", project);
    this.project.teamMember = Array.isArray(this.project.teamMember) ? this.project.teamMember.map((member: any) => member.id) : ['']; 
    this.project.country = project.country[0]['countryID'];
    this.project.language = project.language[0]['languageID'];
       // this.project.teamMember = this.project.teamMember.map((member: any) => member.id)
       
    this.userService.addProjectSecurityDetails(project)
      .subscribe((data: any) => {
        if (data != null && data != undefined) {
          this.router.navigate(['/assignsurverlink/' + this.roleId + "/" + this.project.country + "/" + this.project.language + "/" + this.project.quotatarget + "/" + this.project.optimisticcount])
        }
      });
  }

  isAnyTimeSelected(): boolean {
    return !!(
      this.project.selectedFromHour ||
      this.project.selectedFromMinute ||
      this.project.selectedFromAmpm ||
      this.project.selectedToHour ||
      this.project.selectedToMinute ||
      this.project.selectedToAmpm
    );
  }



}
